"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkColors = exports.LightColors = void 0;
exports.LightColors = {
  base: '#FFFFFF',
  baseOffset: 'whitesmoke',
  baseOffsetLighter: '#C4C9D4',
  textColor: '#020202',
  primary: '#2048A5',
  greyLightest: '#F5F5F5',
  greyLighter: '#E4E4E4',
  greyLight: '#C4C9D4',
  greyDark: '#4E4E4E',
  greyDarker: '#2F2F2F',
  greyDarkest: '#0C0D0E',
  greyBlueSoft: '#EAECF1',
  onColor: '#2048A5',
  offColor: '#C2C2C2',
  disabledColor: '#A0A9BA',
  loadingColor: '#2048A5',
  focus: 'rgba(4, 90, 159, 0.5)',
  backdrop: 'rgb(0,0,0,0.4)',
  green: '#00A53A',
  red: '#FF5757',
  yellow: '#FFB225'
};
exports.DarkColors = {
  base: '#181818',
  baseOffset: '#1f1f1f',
  baseOffsetLighter: '#272727',
  textColor: '#c6c6c6',
  primary: '#286be6',
  greyLightest: '#3A3A3A',
  greyLighter: '#484848',
  greyLight: '#5f5f5f',
  greyDark: '#4E4E4E',
  greyDarker: '#2F2F2F',
  greyDarkest: '#0C0D0E',
  greyBlueSoft: '#EAECF1',
  onColor: '#4E4E4E',
  offColor: '#C2C2C2',
  disabledColor: '#A0A9BA',
  loadingColor: '#c6c6c6',
  focus: 'rgba(4, 90, 159, 0.5)',
  backdrop: 'rgb(0,0,0,0.4)',
  green: '#07b946',
  red: '#f55454',
  yellow: '#ea9905'
};